import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '@material-ui/core/Icon';
import ListItem from '@material-ui/core/ListItem';
import Collapse from '@material-ui/core/Collapse';
import { Tooltip, Zoom } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import KeyboardArrowUp from '@material-ui/icons/KeyboardArrowUp';
import KeyboardArrowDown from '@material-ui/icons/KeyboardArrowDown';
import ShinyBadge from 'components/atoms/ShinyBadge';
import shouldHidden from '../shouldHidden';
import RenderIcons from '../RenderIcons';
import disabledMenu from '../disabledMenu';
import fontDefault from '../fontDefault';
import ListMenu from '../../ListMenu';

const CustomTooltip = withStyles(theme => ({
  arrow: {
    color: theme.palette.secondary.main,
  },
  tooltip: {
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(14),
    left: 0,
    background: '#333333',
  },
  tooltipPlacementRight: {
    margin: 0,
  },
}))(Tooltip);

class FirstLevel extends React.Component {
  shouldComponentUpdate(nextProps) {
    const {
      isDisabled,
      isSelectedAndOpen,
      isClicked,
      open,
      selectedIndex,
    } = this.props;
    if (isDisabled !== nextProps.isDisabled) return true;
    if (isClicked !== nextProps.isClicked) return true;
    if (isSelectedAndOpen !== nextProps.isSelectedAndOpen) return true;
    if (open !== nextProps.open) return true;
    if (selectedIndex !== nextProps.selectedIndex) return true;

    return false;
  }

  render() {
    const {
      hasChildren,
      item,
      id,
      to,
      isDisabled,
      level,
      isSelectedAndOpen,
      handleClick,
      isClicked,
      classes,
      open,
      externalLink,
      ...props
    } = this.props;
    const isHidden = shouldHidden(item.hidden || {});
    if (!hasChildren) {
      return (
        <>
          {!isHidden.desktop && (
            <FirstLevelWithoutChildren
              item={item}
              id={id}
              to={to}
              externalLink={externalLink}
              isDisabled={isDisabled}
              level={level}
              isSelectedAndOpen={isSelectedAndOpen}
              handleClick={handleClick}
              isClicked={isClicked}
              classes={classes}
              open={open}
            />
          )}
        </>
      );
    }

    return (
      <>
        {!isHidden.desktop && (
          <FirstLevelWithChildren
            item={item}
            id={id}
            to={to}
            isDisabled={isDisabled}
            level={level}
            isSelectedAndOpen={isSelectedAndOpen}
            handleClick={handleClick}
            isClicked={isClicked}
            classes={classes}
            open={open}
            {...props}
          />
        )}
      </>
    );
  }
}

const FirstLevelWithoutChildren = ({
  item,
  to,
  isDisabled,
  isSelectedAndOpen,
  handleClick,
  classes,
  open,
  externalLink,
}) => {
  const isSelected = isSelectedAndOpen;
  const selectedItemClass = isSelected
    ? { root: item.id === 'feirao' ? classes.feiraoItem : classes.selectedItem }
    : {
        root:
          item.id === 'feirao' ? classes.feiraoItem : classes.noSelectedItem,
      };
  return (
    <div key={item.id} data-test={item.name}>
      {externalLink ? (
        <a
          target="_blank"
          rel="noreferrer"
          href={externalLink}
          style={{ textDecoration: 'none' }}
          // style={disabledMenu(isDisabled)}
        >
          <CustomTooltip
            title={open ? '' : item.label}
            placement="right"
            TransitionComponent={Zoom}
          >
            <ListItem
              selected={isSelected && !item.disabled}
              classes={{
                selected: open
                  ? classes.selectedRoot
                  : classes.selectedRootClosed,
                root: open ? classes.root : classes.rootClose,
              }}
              disabled={isDisabled}
            >
              <ListItemIcon classes={{ root: classes.menuIcon }}>
                {!open && item.badgeTitle && (
                  <div
                    style={{
                      position: 'absolute',
                      width: 10,
                      height: 10,
                      borderRadius: '50%',
                      background: '#4300d2',
                      right: '-5px',
                      top: '-5px',
                    }}
                  />
                )}
                <Icon>
                  <RenderIcons icon={item.icon} />
                </Icon>
              </ListItemIcon>
              <>
                <ListItemText>
                  <Typography
                    noWrap
                    classes={selectedItemClass}
                    style={{
                      ...fontDefault,
                      fontSize: '12px',
                      fontWeight: '100',
                    }}
                  >
                    {item.label}
                  </Typography>
                </ListItemText>
                {item.badgeTitle && <ShinyBadge title={item.badgeTitle} />}
              </>
            </ListItem>
          </CustomTooltip>
        </a>
      ) : (
        <Link
          to={!isDisabled ? to : undefined}
          style={disabledMenu(isDisabled)}
          onClick={() => handleClick(item.link, isDisabled, false)}
        >
          <CustomTooltip
            title={open ? '' : item.label}
            placement="right"
            TransitionComponent={Zoom}
          >
            <ListItem
              selected={isSelected && !item.disabled}
              classes={{
                selected: open
                  ? item.id === 'feirao'
                    ? classes.feirao
                    : classes.selectedRoot
                  : item.id === 'feirao'
                  ? classes.feirao
                  : classes.selectedRootClosed,
                root: open
                  ? item.id === 'feirao'
                    ? classes.feirao
                    : classes.root
                  : classes.rootClose,
              }}
              disabled={isDisabled}
              {...(item.id === 'feirao' && {
                style: {
                  backgroundColor: '#E5E5E5',
                  '&:hover': { backgroundColor: '#E5E5E5' },
                },
              })}
            >
              <ListItemIcon classes={{ root: classes.menuIcon }}>
                {!open && item.badgeTitle && (
                  <div
                    style={{
                      position: 'absolute',
                      width: 10,
                      height: 10,
                      borderRadius: '50%',
                      background: '#4300d2',
                      right: '-5px',
                      top: '-5px',
                    }}
                  />
                )}
                <Icon>
                  <RenderIcons icon={item.icon} />
                </Icon>
              </ListItemIcon>
              <>
                <ListItemText>
                  <Typography
                    noWrap
                    classes={selectedItemClass}
                    style={{
                      ...fontDefault,
                      fontSize: '12px',
                      fontWeight: '100',
                    }}
                  >
                    {item.label}
                  </Typography>
                </ListItemText>
                {item.badgeTitle && <ShinyBadge title={item.badgeTitle} />}
              </>
            </ListItem>
          </CustomTooltip>
        </Link>
      )}
    </div>
  );
};

const checkChildrenSelected = (links, selectedIndex) =>
  links ? links.includes(selectedIndex) : false;

const FirstLevelWithChildren = ({
  item,
  id,
  to,
  isDisabled,
  level,
  isSelectedAndOpen,
  handleClick,
  isClicked,
  classes,
  isMobile,
  handleDrawerClose,
  open,
  isSelectedAndOpenFunction,
  selectedIndex,
  ...acc
}) => {
  function selectClass() {
    if (isSelectedAndOpen || isClicked) {
      return classes.selectedItem;
    }
    return classes.noSelectedItem;
  }

  const selectedItemClass = selectClass();

  return (
    <div key={item.id} data-test={item.name}>
      <CustomTooltip
        title={open ? '' : item.label}
        placement="right"
        TransitionComponent={Zoom}
      >
        <div
          style={disabledMenu(isDisabled)}
          onClick={() => handleClick(item.link, isDisabled, true)}
        >
          <ListItem
            selected={
              checkChildrenSelected(item.links, selectedIndex) && !item.disabled
            }
            classes={{
              selected: open
                ? classes.selectedRoot
                : classes.selectedRootClosed,
              root: open ? classes.root : classes.rootClose,
            }}
            disabled={isDisabled}
          >
            <ListItemIcon classes={{ root: classes.menuIcon }}>
              {!open && item.badgeTitle && (
                <div
                  style={{
                    position: 'absolute',
                    width: 10,
                    height: 10,
                    borderRadius: '50%',
                    background: '#4300d2',
                    right: '-5px',
                    top: '-5px',
                  }}
                />
              )}
              <Icon>
                <RenderIcons icon={item.icon} />
              </Icon>
            </ListItemIcon>
            <>
              <ListItemText>
                <Typography
                  noWrap
                  classes={{ root: selectedItemClass }}
                  style={{
                    ...fontDefault,
                    fontSize: '12px',
                    fontWeight: '100',
                  }}
                >
                  {item.label}
                </Typography>
              </ListItemText>
              {item.badgeTitle && <ShinyBadge title={item.badgeTitle} />}
              {checkChildrenSelected(item.links, selectedIndex) ? (
                <KeyboardArrowUp
                  style={{ width: 'auto' }}
                  classes={{ root: classes.selectedItem }}
                />
              ) : (
                <KeyboardArrowDown
                  style={{ width: 'auto' }}
                  classes={{ root: classes.root }}
                />
              )}
            </>
          </ListItem>
        </div>
      </CustomTooltip>
      {open && (
        <Collapse
          in={checkChildrenSelected(item.links, selectedIndex)}
          timeout="auto"
          unmountOnExit
        >
          <ListMenu
            {...acc}
            menuTree={item.children}
            level={level + 1}
            classes={classes}
            disabled={isDisabled}
            isMobile={isMobile}
            open={open}
            handleDrawerClose={handleDrawerClose}
          />
        </Collapse>
      )}
    </div>
  );
};

export default FirstLevel;
